var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99081 0.833008C4.93081 0.833008 0.833313 4.93967 0.833313 9.99967C0.833313 15.0597 4.93081 19.1663 9.99081 19.1663C15.06 19.1663 19.1666 15.0597 19.1666 9.99967C19.1666 4.93967 15.06 0.833008 9.99081 0.833008ZM10.9166 10.9163V5.41634H9.08331V10.9163H10.9166ZM10.9166 14.583V12.7497H9.08331V14.583H10.9166ZM2.66665 9.99967C2.66665 14.0513 5.94831 17.333 9.99998 17.333C14.0516 17.333 17.3333 14.0513 17.3333 9.99967C17.3333 5.94801 14.0516 2.66634 9.99998 2.66634C5.94831 2.66634 2.66665 5.94801 2.66665 9.99967Z",
    fill: "#E51635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/ErrorOutline.7956b70f90448daffe9d41e6132fc927.svg";
export { ForwardRef as ReactComponent };